<div>
  <div class="device-picker-select">
    <mat-form-field>
  <mat-label>Assigned Devices</mat-label>
  <mat-select (selectionChange)="handleAssignedBotsChange($event)" [value]="assignedDeviceIds()"  multiple>
    @for (device of devices; track device.id) {
      <mat-option  [value]="device.id">{{device.name}}</mat-option>
    }
  </mat-select>
</mat-form-field>
  </div>
  <mat-tab-group>
  <mat-tab label="Components">
    <div class="sidebarTabContainer">
       <button (click)="handleSaveChanges()" class="sideBarSaveButton" [disabled]="formTouched()  ? false : true" matButton="filled">Save Changes</button>
       @if(selectedComponent != null){
        <app-designer-component-settings (handleComponentChange)=componentChange($event) (pushButtonNameChange)="handlePushButtonNameChange($event)" (pushButtonIdChange)="handlePushButtonIdChange($event)" (closeComponentSettings)="onCloseComponentSettings()" [selectedComponent]="selectedComponent"></app-designer-component-settings> 
       }
       
      <app-designer-cockpit-component-list [components]="components"></app-designer-cockpit-component-list>
      
    </div>
  </mat-tab>
  <mat-tab label="Sections"> 
    <div class="sidebarTabContainer">
    <button (click)="handleSaveChanges()" class="sideBarSaveButton"  [disabled]="formTouched()  ? false : true" matButton="filled">Save Changes</button>
    <app-designer-row-editor> row editor</app-designer-row-editor>

    @if(selectedId() && currentProperties()){
      <app-designer-cockpit-css-properties  [properties]="currentProperties()" (columnsChange)=handleColumnChange($event) (propertiesChange)="handlePropertiesChange($event)"></app-designer-cockpit-css-properties>
    }

    </div>
  </mat-tab>
  <mat-tab label="Video">
    <div class="sidebarTabContainer">
      <button (click)="handleSaveChanges()" class="sideBarSaveButton"  [disabled]="formTouched()  ? false : true" matButton="filled">Save Changes</button>
      <app-cockpit-designer-video-options [videoProperties]="currentVideoConfig()" (onVideoOptionsChange)="handleVideoOptionsChange($event)"></app-cockpit-designer-video-options>
    </div>
  </mat-tab>
</mat-tab-group>
</div>
